import angular from 'angular';
import './styles.styl';

export default angular
	.module('ui.cian.ruble', [])
	.name;



// WEBPACK FOOTER //
// ./~/@cian/ui/app/components/ruble/index.jsm